import React, { Component } from 'react'
import Http from '../../config/axiosUtils';
import { Toast } from 'antd-mobile';
import Swiper from 'swiper/dist/js/swiper.js'
import 'swiper/dist/css/swiper.css'
import './Poster.scss'
class Poster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrObj: [],
      len: 0,
      checkAll: false,
      longClick: 0,  // 长按标志
      timeOutEvent: 0,  // 计时器
      countTount: [],
      isLoading: false,
      tips: '',
      imgData: []
    }
  }
  componentDidMount() {
    this.goApply();
    // this.fetchTitle()
    // const that = this;
    new Swiper('.swiper-container', {
      loop: false,
      direction: 'horizontal',
      autoplayDisableOnInteraction: false,
      slidesPerView: "auto",
      centeredSlides: true,
      // spaceBetween: 20,
      nested: true, // 禁止父级滑块自动滑动功能
      observer: true, //修改swiper自己或子元素时，自动初始化swiper默认为false
      observeParents: true,//修改swiper的父元素时，自动初始化swiper
      effect: 'coverflow',
    });
  }
  goApply = () => {
    Toast.loading('加载中', 1, async () => {
      const path = this.props.path;
      let postData = this.props.postData;
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        let imhLen = res.data && res.data.length;
        let width = 100 / imhLen + 50 + "%";
        this.setState({
          qrObj: res.data,
          len: width,
        })
      } else {

        Toast.fail(res.msg, 2);
      }
    })
  }
  render() {
    return (
      <div>
        <div className="swiper-container">
          <div className="swiper-wrapper">
            {this.state.qrObj.map((obj, index) => <div className="swiper-slide" key={obj.fileId} >
              <img src={obj.fileBase64} alt="" className="fileImg" />
            </div>
            )}
          </div>
        </div>
        <div>
          {this.state.len !== 0 && <p className="erro" >长按海报保存</p>}
        </div>
      </div >
    )
  }
}
export default Poster;

